var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalyzeSaasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 31.005C63 38.735 56.73 45.005 49 45.005V40.995C56.73 40.995 63 34.735 63 26.995V31.005Z",
    fill: "#CCD1D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40.995V45.005H12C5.92 45.005 1 40.075 1 34.005V29.995C1 36.075 5.92 40.995 12 40.995H14.99H15Z",
    fill: "#CCD1D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.24 13.015C56.86 13.135 63 19.355 63 26.995C63 34.735 56.73 40.995 49 40.995C49 36.305 47.101 32.055 44.021 28.975C40.941 25.895 36.691 23.995 32 23.995C22.61 23.995 15 31.615 15 40.995H14.99H12C5.92 40.995 1 36.075 1 29.995C1 23.925 5.92 18.995 12 18.995H13.101H13.111C14.101 9.44499 22.18 1.995 32.001 1.995C39.64 1.995 46.23 6.505 49.24 13.015Z",
    fill: "#E6E9ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40.845L32.08 40.925L32 40.995H31.99H15C15 31.615 22.61 23.995 32 23.995V40.845Z",
    fill: "#967ADC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.021 28.976L32.08 40.925L32 40.845V23.995C36.69 23.995 40.94 25.896 44.021 28.976Z",
    fill: "#A0D468"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40.995V45.005C49 49.695 47.101 53.955 44.021 57.026V53.015C47.101 49.936 49 45.695 49 40.995Z",
    fill: "#37BC9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.021 28.976C47.101 32.055 49 36.305 49 40.995C49 45.695 47.101 49.935 44.021 53.015L32 40.995L32.08 40.925L44.021 28.976Z",
    fill: "#48CFAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40.995C15 50.385 22.61 57.995 32 57.995C36.69 57.995 40.94 56.095 44.021 53.015V57.026C40.941 60.106 36.691 62.005 32 62.005C22.61 62.005 15 54.396 15 45.005V40.995Z",
    fill: "#4A89DC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40.995L44.021 53.015C40.941 56.095 36.691 57.995 32 57.995C22.61 57.995 15 50.385 15 40.995H31.99H32Z",
    fill: "#5D9CEC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeSaasLogo);
export default __webpack_public_path__ + "static/media/analyze-saas-logo.a4eff9db813e70a93a550752dd573857.svg";
export { ForwardRef as ReactComponent };